<template>
  <div class="tw-w-full tw-mt-6 tw-mb-20">
    <button
      type="submit"
      class="onboarding-btn"
      :disabled="loading"
    >
      <span v-show="!loading">{{ title }}</span>
      <ButtonLoader v-show="loading" color="white" size="medium" />
    </button>
  </div>
</template>

<script>
import ButtonLoader from "@/components/notification/ButtonLoader.vue";

export default {
  name: "OnboardingBtn",

  components: {
    ButtonLoader,
  },

  emits: ["btnClicked"],

  props: {
    title: { type: String, default: () => "", required: true },
    loading: { type: Boolean, default: () => false },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-btn {
  width: 100%;
  background: #4D84FF;
  border-radius: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: white;
  padding: 14px 24px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  
  &:hover:not(:disabled) {
    background: #3B6FE8;
    transform: translateY(-1px);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}
</style>
